import React, { useState } from 'react';
import './Help.css';
import { Accordion } from './components';
import { faqsGeneral, faqsEnergyReports, faqsDiagnostics } from './assets';
// import { SearchBar } from '../SearchBar';

const categoryList = [
  { name: 'general', title: 'General' },
  { name: 'energyReports', title: 'Energy Reports' },
  { name: 'diagnostics', title: 'Diagnostics' },
  { name: 'contact', title: 'Contact Us' },
];

export default function Help() {
  const [activeCategory, setActiveCategory] = useState(faqsGeneral);
  const [mobileCategory, setMobileCategory] = useState('');

  const handleClick = (category: string = '') => {
    if (category === mobileCategory) {
      setMobileCategory('');
    } else {
      setMobileCategory(category);
      switch (category) {
        case 'general':
          setActiveCategory(faqsGeneral);
          break;
        case 'energyReports':
          setActiveCategory(faqsEnergyReports);
          break;
        case 'diagnostics':
          setActiveCategory(faqsDiagnostics);
          break;
        case 'contact':
          setActiveCategory({ name: 'contact', list: [] });
          break;
      }
    }
  };

  const renderContactUs = () => {
    return (
      <div>
        <div className="help-about__title help__desktop">Contact Us</div>
        <div className="help-about__text">
          Got a question? We'd love to hear from you. Send us an email and we will respond as soon as possible.
        </div>
        <a className="help-about__email" href="mailto:support@paritygo.com">
          support@paritygo.com
        </a>
      </div>
    );
  };

  const renderMobile = () => {
    if (mobileCategory === 'contact') {
      return <div className="help__mobile">{renderContactUs()}</div>;
    } else {
      return (
        <div className="help__mobile">
          <Accordion category={activeCategory.name} elements={activeCategory.list} />
        </div>
      );
    }
  };

  return (
    <div className="help">
      <div className="help__header">
        <span className="help__title">Help Center</span>
        {/* <span className="help__search">
          <SearchBar placeholderText="Enter a search term here." />
        </span> */}
      </div>
      <div className="help__main">
        <div className="help__navbar">
          <div className="help__category-wrapper">
            {categoryList.map((category, index) => {
              const key = `${index}-${category.name}`;
              let buttonText = 'help__button-text';
              buttonText += category.name === activeCategory.name ? ' help__button-text--selected' : '';

              return (
                <div key={key} className="help__category">
                  <button onClick={() => handleClick(category.name)}>
                    <div className={buttonText}>{category.title}</div>
                  </button>
                  {mobileCategory === category.name && renderMobile()}
                </div>
              );
            })}
          </div>
        </div>
        <div className="help__body-desktop">
          {mobileCategory === 'contact' ? (
            renderContactUs()
          ) : (
            <Accordion category={activeCategory.name} elements={activeCategory.list} />
          )}
        </div>
      </div>
    </div>
  );
}
